import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Buefy from 'buefy'

// require("@webcomponents/webcomponentsjs/webcomponents-bundle.js")
import "@webcomponents/webcomponentsjs/webcomponents-bundle.js";

Vue.config.productionTip = false
Vue.use(Buefy);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
